import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AppShell } from '@/components/layout/AppShell'
import { RequireAuth } from '@/components/auth/RequireAuth'
import { LoginPage } from '@/features/auth/components/LoginPage'
import { HomePage } from '@/features/home/components/HomePage'
import { StewardPage } from '@/features/steward/StewardPage'
// >>> NEW_WORKFLOW_IMPORT — commissioning-workflows inserts imports here <<<

// Lazy: tldraw is ~700KB gzipped — keep it out of the main bundle.
const CanvasPage = lazy(() =>
  import('@/features/canvas/CanvasPage').then((m) => ({ default: m.CanvasPage }))
)
const SclaPage = lazy(() => import('@/features/scla/SclaPage').then(m => ({ default: m.SclaPage })))

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="scla" element={<Suspense fallback={<div className="h-dvh bg-neutral-950" />}><SclaPage /></Suspense>} />
        {/* Auth */}
        <Route path="login" element={<LoginPage />} />

        {/* Authenticated app — AppShell provides the header + nav. */}
        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route index element={<HomePage />} />

          <Route path="steward" element={<StewardPage />} />
          <Route
            path="canvas"
            element={
              <Suspense fallback={null}>
                <CanvasPage />
              </Suspense>
            }
          />
          {/* >>> NEW_WORKFLOW_ROUTES — do not remove; commissioning-workflows inserts here <<< */}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
